"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowSummary = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Button_1 = require("@amzn/atoz-web/Button");
const Responsive_1 = require("@amzn/atoz-web/Responsive");
const Text_1 = require("@amzn/atoz-web/Text");
const View_1 = require("@amzn/atoz-web/View");
const Flex_1 = require("@amzn/atoz-web/Flex");
const Theme_1 = require("@amzn/atoz-web/Theme");
const ToastIcon_1 = require("../../../components/Shared/ToastIcon");
const WorkflowSummary = ({ dataTestId, status, title, supportingText, detailsTitle, detailsSubText, detailsNote, onBack, onClose, renderSummaryContent, closeButtonAriaLabel }) => {
    const { matches } = (0, Responsive_1.useBreakpoints)();
    const isMobileViewPoint = !!matches.s;
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(View_1.View, { dataTestId: dataTestId || 'WorkflowSummary', margin: { top: 'S500' } },
        react_1.default.createElement(IconTitleWrapper, null,
            react_1.default.createElement(ToastIcon_1.ToastIcon, { status: status }),
            react_1.default.createElement(Text_1.H1, { fontWeight: 500, fontSize: "T500", margin: { top: 'S200' } }, title)),
        react_1.default.createElement(Text_1.Text, { textAlign: "center", color: "neutral80" }, supportingText),
        (detailsTitle || detailsSubText) && (react_1.default.createElement(Flex_1.Flex, { flexDirection: "column", rowGap: 8, margin: { top: 'S400' } },
            detailsTitle && react_1.default.createElement(Text_1.H2, { fontSize: "T500" }, detailsTitle),
            detailsSubText && react_1.default.createElement(Text_1.Text, { color: "neutral80" }, detailsSubText))),
        detailsNote && (react_1.default.createElement(Text_1.Text, { fontSize: "T100", color: "neutral80", margin: { top: 'S400' } }, detailsNote)),
        renderSummaryContent && (react_1.default.createElement(Flex_1.Flex, { flexDirection: "row", justifyContent: "center", margin: { top: 'S400' } }, renderSummaryContent())),
        react_1.default.createElement(BottomBtnWrapper, { flexDirection: isMobileViewPoint ? 'column' : 'row', gridGap: "S300", isMobileViewPoint: isMobileViewPoint },
            onBack && (react_1.default.createElement(Button_1.Button, { variant: Button_1.ButtonVariant.Secondary, onClick: onBack, "aria-label": t('time_and_attendance_PunchWorkflow_Back_A11y') }, t('time_and_attendance_Back'))),
            react_1.default.createElement(Button_1.Button, { variant: Button_1.ButtonVariant.Primary, onClick: onClose, "aria-label": t(`${closeButtonAriaLabel}`) }, t('time_and_attendance_Close')))));
};
exports.WorkflowSummary = WorkflowSummary;
const IconTitleWrapper = (0, Theme_1.styledWithTheme)(View_1.View)(({ theme }) => `
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.selectors.space('S200')}px;
  `);
const BottomBtnWrapper = (0, Theme_1.styledWithTheme)(Flex_1.Flex)(({ theme, isMobileViewPoint }) => `
    margin-top: ${theme.selectors.space('S400')}px;
    justify-content: ${isMobileViewPoint ? 'stretch' : 'flex-end'};
    flex-flow: ${isMobileViewPoint ? 'column-reverse' : 'row'}
  `);
